import React from 'react'
import Moment from 'react-moment'

function FullDateForrmat(props) {
  return (
    <Moment format='ddd, ll'>{props.children}</Moment>
  )
}

export default FullDateForrmat